import { View, StyleSheet } from 'react-native';
import { Appbar } from 'react-native-paper';

import { ScreenAppbar } from '@/components/atoms';
import { AiBatonList } from '@/components/organisms/ai-baton';
import { useTranslation } from '@/i18n';
import { unisonColors, useAppTheme } from '@/theme';

export const AiTasks = () => {
  const { t } = useTranslation();
  const { colors } = useAppTheme();

  return (
    <View style={styles.container}>
      <ScreenAppbar testID="ai-tasks-appbar">
        <Appbar.Content title={t('aiTasks.title')} titleStyle={{ color: colors.textNdPrimary }} />
      </ScreenAppbar>
      <AiBatonList />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: unisonColors.bgNlWeak,
  },
});
